import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/data/catalog';
import { CONTACT_EMAIL } from '@/data/site';

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-950 pb-16 text-background-200 md:pb-0">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-flashlight-fill text-xl" />
              </span>
              <span className="text-xl font-black tracking-tight text-background-50">大雷影视</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300/80">
              一个专注影视发现与资料查询的内容平台。我们用清晰的分类、完整的资料和用心的专题，帮你在海量作品里更快找到想看的那一部。
            </p>
            <p className="mt-4 text-xs text-background-400">本站内容为演示数据，仅用于展示产品形态。</p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-medium text-background-50">
              <span className="text-accent-400">/ </span>内容导航
            </h4>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: '首页推荐', path: '/' },
                { label: '电影分类', path: '/category/movie' },
                { label: '电视剧分类', path: '/category/tv' },
                { label: '影视专题', path: '/special/special-01' },
                { label: '搜索影视', path: '/search' },
                { label: '关于大雷', path: '/about' },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="cursor-pointer text-background-300/80 transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-medium text-background-50">
              <span className="text-accent-400">/ </span>分类直达
            </h4>
            <ul className="space-y-2.5 text-sm">
              {CATEGORIES.map((item) => (
                <li key={item.key}>
                  <Link
                    to={`/category/${item.key}`}
                    className="cursor-pointer text-background-300/80 transition-colors hover:text-accent-300"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-medium text-background-50">
              <span className="text-accent-400">/ </span>联系与合作
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <a href={`mailto:${CONTACT_EMAIL}`} className="cursor-pointer break-all hover:text-accent-300">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                <span>工作日 10:00 - 18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-accent-400" />
                <span>内容合作、纠错反馈欢迎来信</span>
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: 'ri-weibo-fill', label: '微博' },
                { icon: 'ri-wechat-fill', label: '微信' },
                { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="https://www.example.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`大雷影视${social.label}`}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-background-200 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 大雷影视大全 · 演示站点，页面内容与作品均为示例数据</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>友情链接：</span>
            <a href="https://www.example.com" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-accent-300">
              影视资料库
            </a>
            <a href="https://www.example.com" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-accent-300">
              观影指南
            </a>
            <a href="https://www.example.com" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-accent-300">
              电影节资讯
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}